import React, { useEffect, useRef, useState } from 'react';
import styles from './index.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { showToast } from '../../../../components/ToastMsg';
import BeatLoader from 'react-spinners/BeatLoader';
import {
  editLotteryBrandDays,
  getAllLotteryBrandDay,
} from '../../../../redux/features/lotteryBrandDay/lotteryBrandDayService';
import GridLoader from 'react-spinners/GridLoader';

const EditLotteryBrandDays = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const { isLotteryBrandDayLoading, lotteryBrandDay } = useSelector(
    (state) => state.lotteryBrandDay.allLotteryBrandDay
  );

  const { isEditingLotteryBrandDays } = useSelector(
    (state) => state.lotteryBrandDay.editLotteryBrandDays
  );

  const [selectedLotteryBrand, setSelectedLotteryBrand] = useState({
    name: '',
    code: '',
    lotterybrandId: '',
    sampleImage: null,
  });

  const [brandName, setBrandName] = useState('');
  const [previewSampleImage, setPreviewSampleImage] = useState(null);

  const [errorMessages, setErrorMessages] = useState({
    name: '',
    code: '',
    lotterybrandId: '',
    sampleImage: '',
  });
  const [disabledBtn, setBtnDisable] = useState(false);
  const dropdownRef = useRef(null);
  const fileInputRefSample = useRef(null);
  const [initialLottery, setInitialLottery] = useState(null);

  useEffect(() => {
    dispatch(getAllLotteryBrandDay({}));
  }, [dispatch]);

  useEffect(() => {
    if (lotteryBrandDay && id) {
      const foundLottery = lotteryBrandDay.find((lottery) => lottery.id === id);
      if (foundLottery) {
        setSelectedLotteryBrand({
          ...foundLottery,
        });

        setInitialLottery({ ...foundLottery });
        if (foundLottery.lottery_brand?.name) {
          setBrandName(foundLottery.lottery_brand.name);
        }
        if (foundLottery.sample_url) {
          setPreviewSampleImage(foundLottery.sample_url);
        }
      }
    }
  }, [lotteryBrandDay, id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedLotteryBrand((prev) => ({ ...prev, [name]: value }));
    setErrorMessages((prev) => ({ ...prev, [name]: '' }));
  };

  const handleFileChange = (event, fieldName) => {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      if (!validateFile(file, fieldName)) {
        return;
      }

      setSelectedLotteryBrand((prev) => ({ ...prev, [fieldName]: file }));

      const fileURL = URL.createObjectURL(file);
      if (fieldName === 'sampleImage') setPreviewSampleImage(fileURL);
    }
  };

  const handleDrop = (event, fieldName) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];

    if (!validateFile(file, fieldName)) {
      return;
    }

    setSelectedLotteryBrand((prev) => ({ ...prev, [fieldName]: file }));
    const fileURL = URL.createObjectURL(file);
    if (fieldName === 'sampleImage') setPreviewSampleImage(fileURL);
  };

  const validateFile = (selectedFile, fieldName) => {
    const allowedTypes = ['image/jpeg', 'image/png', 'image/gif'];

    if (!allowedTypes.includes(selectedFile.type)) {
      setErrorMessages((prev) => ({
        ...prev,
        [fieldName]: 'Invalid file type. Allowed types: JPEG, PNG, GIF',
      }));

      setSelectedLotteryBrand((prev) => ({ ...prev, [fieldName]: null }));
      setBtnDisable(true);
      return false;
    }

    setErrorMessages((prev) => ({ ...prev, [fieldName]: '' }));
    setBtnDisable(false);
    return true;
  };

  const isValidLotteryBrand = () => {
    const errors = {};
    const trimmedName = selectedLotteryBrand.name.trim();
    const trimmedCode = selectedLotteryBrand.code.trim();

    if (!trimmedName) {
      errors.name = 'Lottery Name is required.';
    }
    if (!trimmedCode) {
      errors.code = 'Lottery Brand code is required.';
    }

    if (Object.keys(errors).length > 0) {
      setErrorMessages(errors);
      return false;
    } else {
      return true;
    }
  };

  function getChangedValues(selectedData) {
    const changedValues = {};
    if (!initialLottery) {
      return {};
    }
    for (const key in selectedData) {
      if (
        key !== 'id' &&
        selectedData.hasOwnProperty(key) &&
        selectedData[key] !== initialLottery[key]
      ) {
        changedValues[key] = selectedData[key];
      }

      if (key === 'id') {
        changedValues[key] = selectedData[key];
      }
    }
    return changedValues;
  }

  const updateLotteryBrand = async () => {
    if (!isValidLotteryBrand()) {
      return;
    }
    if (
      selectedLotteryBrand.sampleImage &&
      !validateFile(selectedLotteryBrand.sampleImage, 'sampleImage')
    ) {
      return;
    }

    const changedValues = getChangedValues(selectedLotteryBrand);
    const hasChanges = Object.keys(changedValues).some((key) => key !== 'id');

    if (!hasChanges) {
      showToast('error', 'There are no changes to update.');
    } else {
      setBtnDisable(true);
      try {
        const response = await dispatch(
          editLotteryBrandDays({ id, ...changedValues })
        ).unwrap();
        setBtnDisable(null);
        setInitialLottery({ ...selectedLotteryBrand });
        showToast('success', response.message);
        dropdownRef.current?.clearSelection();
      } catch (error) {
        setBtnDisable(false);
        showToast('error', error.message);
      }
    }
  };

  return (
    <div className={`card-section`}>
      <div className={`main-card`}>
        <h1 className={`form-title`}>Edit Lottery Brand Day</h1>
        <div className={styles.formContainer}>
          {isLotteryBrandDayLoading ? (
            <div className={`loader-style`}>
              <GridLoader color='var(--primary)' />
            </div>
          ) : (
            <form className={styles.coordinatorForm} noValidate>
              <div className={`form-input-row`}>
                <div className={`form-input-col`}>
                  <div className={`form-input-group`}>
                    <label htmlFor='lottery-brand' className={`form-label`}>
                      Lottery Brand<span className={`required-star`}>*</span>
                    </label>
                    <input
                      type='text'
                      value={brandName || ''}
                      readOnly
                      className={`form-input-default`}
                    />
                    {errorMessages.lotterybrandId && (
                      <p className={`text-danger`}>
                        {errorMessages.lotterybrandId}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div className={`form-input-row`}>
                <div className={`form-input-col`}>
                  <div className={`form-input-group`}>
                    <label htmlFor='full_name' className={`form-label`}>
                      Name<span className={`required-star`}>*</span>
                    </label>
                    <input
                      type='text'
                      id='name'
                      name='name'
                      value={selectedLotteryBrand.name || ''}
                      onChange={handleInputChange}
                      placeholder='Enter Lottery Brand Name'
                      className={`form-input-default`}
                    />
                    {errorMessages.name && (
                      <p className={`text-danger`}>{errorMessages.name}</p>
                    )}
                  </div>
                </div>
              </div>

              <div className={`form-input-row`}>
                <div className={`form-input-col`}>
                  <div className={`form-input-group`}>
                    <label htmlFor='code' className={`form-label`}>
                      Code<span className={`required-star`}>*</span>
                    </label>
                    <input
                      type='text'
                      id='code'
                      name='code'
                      value={selectedLotteryBrand.code}
                      onChange={handleInputChange}
                      placeholder='Enter Lottery Brand Code'
                      className={`form-input-default`}
                    />
                    {errorMessages.code && (
                      <p className={`text-danger`}>{errorMessages.code}</p>
                    )}
                  </div>
                </div>
              </div>

              <div className={`form-input-row`}>
                <div className={`form-input-col`}>
                  <div className={`form-input-group`}>
                    <label htmlFor='full_name' className={`form-label`}>
                      Sample Lottery Image
                      <span className={`required-star`}>*</span>
                    </label>
                    <div
                      onDrop={(e) => handleDrop(e, 'sampleImage')}
                      onDragOver={(event) => event.preventDefault()}
                      onClick={() => fileInputRefSample.current.click()}
                      className={styles.dropInput}
                    >
                      <input
                        type='file'
                        ref={fileInputRefSample}
                        accept='image/*'
                        onChange={(e) => handleFileChange(e, 'sampleImage')}
                        style={{ display: 'none' }}
                      />
                      {previewSampleImage ? (
                        <div className={styles.insertedFile}>
                          <div className={styles.fileCard}>
                            <img
                              src={previewSampleImage}
                              alt='Sample'
                              className={styles.thumbnailImg}
                            />
                          </div>
                        </div>
                      ) : (
                        <p>Sample Lottery Image</p>
                      )}
                    </div>
                    {errorMessages.sampleImage && (
                      <p className={`text-danger`}>
                        {errorMessages.sampleImage}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <button
                className={`btn-primary`}
                type='button'
                disabled={disabledBtn}
                onClick={updateLotteryBrand}
              >
                {isEditingLotteryBrandDays ? (
                  <BeatLoader grade='#ffffff' />
                ) : (
                  `Save`
                )}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default EditLotteryBrandDays;
